import { COUNTRIES } from '../../../helpers/countries';

export const minMultiplierValue = {
  [COUNTRIES.USA.code]: 1.0,
  [COUNTRIES.AUS.code]: 2.5,
};
